import type { FC } from 'react';
import { Box, Tooltip } from '@mui/material';
import ImageIcon from '@mui/icons-material/ImageOutlined';

interface CreativePreviewCellProps {
  previewLink: string | null;
  name: string;
}

const CreativePreviewCell: FC<CreativePreviewCellProps> = ({ previewLink, name }) => {
  if (!previewLink) {
    return (
      <Box
        sx={{
          width: 40,
          height: 40,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'grey.100',
          borderRadius: 1,
        }}
      >
        <ImageIcon sx={{ color: 'grey.400', fontSize: 20 }} />
      </Box>
    );
  }

  return (
    <Tooltip
      title={
        <Box
          component="img"
          src={previewLink}
          alt={name}
          sx={{ maxWidth: 300, maxHeight: 300, borderRadius: 1 }}
        />
      }
      placement="right"
      arrow
    >
      <Box
        component="img"
        src={previewLink}
        alt={name}
        sx={{
          width: 40,
          height: 40,
          objectFit: 'cover',
          borderRadius: 1,
          cursor: 'pointer',
        }}
      />
    </Tooltip>
  );
};

export default CreativePreviewCell;
